
export enum UserTypeEnum {
    Anonymous = 0,
    Internal = 1,
    Jobseeker = 2,
    CustomerAgent = 3,
    Employer = 4
}